import 'jquery-match-height';

$(() => {
	$('.slide_body').matchHeight();
});